export default {
  groups: [
    { name: "Datasets",
      members: [
    { name: "3D Scene Graph: A Structure for Unified Semantics, 3D Space, and Camera",
     img: "/assets/publications/images/spacegraph.png",
     title: "",
     authorsText: "Iro Armeni, Zhi-Yang He, JunYoung Gwak, Amir R. Zamir, Martin Fischer, Jitendra Malik, Silvio Savarese",
     venue: "ICCV",
     date: "2019",
     location: "",
     link: "",
     refs: [
       {href: "https://3dscenegraph.stanford.edu/",
        text: "Project",
       },
       {href: "https://3dscenegraph.stanford.edu/database.html",
        text: "Dataset",
       },
      ],
    },
    { name: "RoboTurk: A Crowdsourcing Platform for Robotic Skill Learning through Imitation",
     img: "/assets/publications/images/mandlekar2018corl.png",
     title: "",
     authorsText: "Ajay Mandlekar, Yuke Zhu, Animesh Garg, Jonathan Booher, Max Spero, Albert Tung, Julian Gao, John Emmons, Anchit Gupta, Emre Orbay, Silvio Savarese, Li Fei-Fei",
     venue: "Conference on Robot Learning (CoRL)",
     date: "2018",
     location: "",
     link: "",
     refs: [
       {href: "http://roboturk.stanford.edu",
        text: "Project",
       },
       {href: "http://roboturk.stanford.edu/dataset",
        text: "Dataset",
       },
      ],
    },
    { name: "Gibson Env: Real-World Perception for Embodied Agents",
     img: "/assets/publications/images/gibson-env.gif",
     title: "",
     authorsText: "Fei Xia*, Amir Zamir*, Zhiyang He*, Alexander Sax, Jitendra Malik, Silvio Savarese",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2018",
     location: "",
     link: "",
     refs: [
       {href: "http://gibson.vision/",
        text: "Project",
       },
       {href: "https://github.com/StanfordVL/GibsonEnv",
        text: "Code",
       },
      ],
    },
    { name: "Taskonomy: Disentangling Task Transfer Learning",
     img: "/assets/publications/images/taskonomy_thumbnail_loop.gif",
     title: "",
     authorsText: "Amir R. Zamir, Alexander Sax*, William B. Shen* Leonidas Guibas, Jitendra Malik, Silvio Savarese",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2018",
     location: "",
     link: "",
     refs: [
       {href: "https://taskonomy.vision/",
        text: "Project",
       },
       {href: "https://github.com/StanfordVL/taskonomy/tree/master/taskbank",
        text: "Code",
       },
       {href: "https://taskonomy.vision/tasks",
        text: "Online Demo",
       },
      ],
    },
    { name: "Text2Shape: Generating Shapes from Natural Language by Learning Joint Embeddings",
     img: "http://text2shape.stanford.edu/figures/voxelizations-1.png",
     title: "",
     authorsText: "Kevin Chen, Christopher B Choy, Manolis Savva, Angel X Chang, Thomas Funkhouser, Silvio Savarese",
     venue: "(In Submission)",
     date: "2018",
     location: "",
     link: "",
     refs: [
       {href: "http://text2shape.stanford.edu/",
        text: "Project",
       },
      ],
    },
    { name: "ActivityNet Captions",
     img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/published/209126309.png?1493688470",
     title: "",
     authorsText: "Ranjay Krishna, Kenji Hata, Frederic Ren, Li Fei-Fei, Juan Carlos Niebles",
     venue: "International Conference on Computer Vision (ICCV)",
     date: "2017",
     location: "",
     link: "",
     refs: [
       {href: "http://cs.stanford.edu/people/ranjaykrishna/densevid/captions.zip",
        text: "Project",
       },
      ],
    },
    { name: "Inferring and Executing Programs for Visual Reasoning",
     img: "https://cs.stanford.edu/people/jcjohns/images/iep_thumb.png",
     title: "",
     authorsText: "Justin Johnson, Bharath Hariharan, Laurens van der Maaten, Judy Hoffman, Li Fei-Fei, C. Lawrence Zitnick, Ross Girshick",
     venue: "International Conference on Computer Vision (ICCV)",
     date: "2017",
     location: "",
     link: "",
     refs: [
       {href: "https://cs.stanford.edu/people/jcjohns/iep/",
        text: "Project",
       },
      ],
    },
    { name: "Visual Genome Paragraphs",
     img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/screen-shot-2016-11-22-at-12-41-31-am.png?240",
     title: "",
     authorsText: "Jonathan Krause, Justin Johnson, Ranjay Krishna, Li Fei-Fei",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2017",
     location: "",
     link: "",
     refs: [
       {href: "http://visualgenome.org/static/data/dataset/paragraphs_v1.json.zip",
        text: "Project",
       },
      ],
    },
    { name: "CLEVR: A Diagnostic Dataset for Compositional Language and Elementary Visual Reasoning",
     img: "https://cs.stanford.edu/people/jcjohns/papers/clevr/teaser_crop.jpg",
     title: "",
     authorsText: "Justin Johnson, Bharath Hariharan, Laurens van der Maaten, Li Fei-Fei, C. Lawrence Zitnick, Ross Girshick",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2017",
     location: "",
     link: "",
     refs: [
       {href: "https://cs.stanford.edu/people/jcjohns/clevr/",
        text: "Project",
       },
      ],
    },
    { name: "Image2mass Dataset",
     img: "http://trevorstandley.com/images/image2mass.png",
     title: "",
     authorsText: "Trevor Standley, Ozan Sener, Dawn Chen, Silvio Savarese",
     venue: "CORL",
     date: "2017",
     location: "",
     link: "",
     refs: [
        {href: "https://github.com/tstandley/image2mass",
        text: "Project",
       },
      ],
    },
    { name: "Stanford 2D-3D-Semantics Dataset (2D-3D-S)",
     img: "http://buildingparser.stanford.edu/images/equirect.png",
     title: "Joint 2D-3D-Semantic Data for Indoor Scene Understanding",
     authorsText: "Iro Armeni, Alexander Sax, Amir R. Zamir, Silvio Savarese",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2017",
     location: "",
     link: "http://buildingparser.stanford.edu/dataset.html",
     refs: [
       {href: "http://3dsemantics.stanford.edu",
        text: "Project",
       },
       {href: "https://github.com/alexsax/2D-3D-Semantics",
        text: "Data",
       },
      ],
    },
    { name: "Visual7W: Grounded Question Answering in Images",
       img: "https://web.stanford.edu/~yukez/images/img/visual7w_examples.png",
       title: "",
       authorsText: "Yuke Zhu, Oliver Groth, Michael Bernstein and Li Fei-Fei",
       venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
       date: "2016",
       location: "",
       link: "",
       refs: [
         {href: "https://web.stanford.edu/~yukez/visual7w/index.html",
          text: "Project",
         },
         {href: "https://github.com/yukezhu/visual7w-qa-models",
          text: "Code",
         },
        ],
      },
    { name: "Visual Relationship Detection with Language Priors",
     img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/4497960_orig.png",
     title: "",
     authorsText: "Cewu Lu*, Ranjay Krishna*, Michael Bernstein, Li Fei-Fei",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2016",
     location: "",
     link: "",
     refs: [
       {href: "http://cs.stanford.edu/people/ranjaykrishna/vrd/dataset.zip",
        text: "Project",
       },
      ],
    },
    { name: "Visual Genome",
     img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/439313586.png?217",
     title: "",
     authorsText: "Ranjay Krishna, Yuke Zhu, Oliver Groth, Justin Johnson, Kenji Hata, Joshua Kravitz, Stephanie Chen, Yannis Kalantidis, Li Jia-Li, David Ayman Shamma, Michael Bernstein, Li Fei-Fei",
     venue: "IJCV",
     date: "2016",
     location: "",
     link: "",
     refs: [
       {href: "https://visualgenome.org/",
        text: "Project",
       },
      ],
    },
    { name: "Stanford Large-Scale Indoor Spaces 3D (S3DIS)",
     img: "http://buildingparser.stanford.edu/images/3Dmodal.png",
     title: "3D Semantic Parsing of Large-Scale Indoor Space",
     authorsText: "Iro Armeni, Ozan Sener, Amir R. Zamir, Helen Jiang, Ioannis Brilakis, Martin Fischer and Silvio Savarese",
     venue: "IEEE International Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2016",
     location: "",
     link: "https://goo.gl/forms/4SoGp4KtH1jfRqEj2",
     refs: [
       {href: "http://buildingparser.stanford.edu/dataset.html",
        text: "Project",
       },
       {href: "http://buildingparser.stanford.edu/dataset.html#Download",
        text: "Data",
       },
      ],
    },
    { name: "Human Trajectory",
     img: "http://cvgl.stanford.edu/projects/uav_data/hyang.jpg",
     title: "Stanford Drone Dataset, in Learning Social Etiquette: Human Trajectory Prediction In Crowded Scenes",
     authorsText: "A. Robicquet, A. Sadeghian, A. Alahi, S. Savarese",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2016",
     location: "",
     link: "https://doi.org/10.1109/CVPR.2014.109",
     refs: [
       {href: "http://cvgl.stanford.edu/projects/uav_data/",
        text: "Project",
       },
       {href: "http://vatic2.stanford.edu/stanford_campus_dataset.zip",
        text: "Data",
       },
       {href: "https://www.youtube.com/watch?v=c6xQ6iz6wH8",
        text: "Video",
       },
      ],
    },
    { name: "ObjectNet3D",
     img: "http://cvgl.stanford.edu/projects/objectnet3d/ObjectNet3D.png",
     title: "ObjectNet3D: A Large Scale Database for 3D Object Recognition",
     authorsText: "Yu Xiang, Wonhui Kim, Wei Chen, Jingwei Ji, Christopher Choy, Hao Su, Roozbeh Mottaghi, Leonidas Guibas, and Silvio Savarese",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2016",
     location: "",
     link: "http://cvgl.stanford.edu/projects/objectnet3d/ObjectNet3D.png",
     refs: [
       {href: "http://cvgl.stanford.edu/projects/objectnet3d/",
        text: "Project",
       },
       {href: "https://github.com/yuxng/ObjectNet3D_toolbox",
        text: "Code",
       },
       {href: "ftp://cs.stanford.edu/cs/cvgl/ObjectNet3D/ObjectNet3D_images.zip",
        text: "Data",
       },
      ],
    },
    { name: "Image Retrieval using Scene Graphs",
     img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/2108701.png?194",
     title: "",
     authorsText: "Justin Johnson, Ranjay Krishna, Michael Stark, Li-Jia Li, David Ayman Shamma, Michael Bernstein, Li Fei-Fei",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2015",
     location: "",
     link: "",
     refs: [
       {href: "http://imagenet.stanford.edu/internal/jcjohns/scene_graphs/sg_dataset.zip",
        text: "Project",
       },
      ],
    },
    { name: "Robustness to Outliers in Manhattan Frame Estimation",
     img: "http://www.niebles.net/images/manhattan.jpg",
     title: "Robust Manhattan Frame Estimation from a Single RGB-D Image",
     authorsText: "Bernard Ghanem, Ali Thabet, Juan Carlos Niebles, Fabian Caba",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2015",
     location: "",
     link: "https://doi.org/10.1109/CVPR.2015.7299001",
     refs: [
       {href: "https://ivul.kaust.edu.sa/Pages/Pub-Manhattan-Frame-Estimation-CVPR-2015.aspx",
        text: "Project",
       },
       {href: "https://ivul.kaust.edu.sa/Documents/more/code/MFE.zip",
        text: "Code",
       },
       {href: "https://ivul.kaust.edu.sa/Documents/Data/Robust%20Manhattan%20Frame%20Estimation%20from%20a%20Single%20RGB-D%20Image.zip",
        text: "Data",
       },
      ],
    },
    { name: "ActivityNet",
     img: "http://www.niebles.net/images/anet_cvpr15b.jpg",
     title: "ActivityNet: A Large-Scale Video Benchmark for Human Activity Understanding",
     authorsText: "Fabian Caba, Victor Escorcia, Bernard Ghanem, Juan Carlos Niebles",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2015",
     location: "",
     link: "https://doi.org/10.1109/CVPR.2015.7298698",
     refs: [
       {href: "http://activity-net.org/",
        text: "Project",
       },
       {href: "https://github.com/activitynet/ActivityNet",
        text: "Code",
       },
       {href: "http://activity-net.org/download.html",
        text: "Data",
       },
      ],
    },
    { name: "Street View Image, Pose, and 3D Cities",
     img: "https://raw.githubusercontent.com/amir32002/3D_Street_View/master/misc/3D_models_tile_black.jpg",
     title: "Generic 3D Representation via Pose Estimation and Matching",
     authorsText: "Amir R Zamir, Tilman Wekel, Pulkit Agrawal, Jitendra Malik, Silvio Savarese.",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2015",
     location: "",
     link: "http://cvgl.stanford.edu/papers/zamir_eccv16.pdf",
     refs: [
       {href: "http://3drepresentation.stanford.edu/",
        text: "Project",
       },
       {href: "https://github.com/amir32002/3D_Street_View",
        text: "Code",
       },
       {href: "https://goo.gl/ERPCsa",
        text: "Data",
       },
      ],
    },
    { name: "PASCAL3D+",
     img: "http://cvgl.stanford.edu/projects/pascal3d+/pascal3d.png",
     title: "Beyond PASCAL: A Benchmark for 3D Object Detection in the Wild",
     authorsText: "Yu Xiang, Roozbeh Mottaghi and Silvio Savarese",
     venue: "IEEE Winter Conference on Applications of Computer Vision (WACV)",
     date: "2014",
     location: "",
     link: "https://doi.org/10.1109/CVPR.2014.109",
     refs: [
       {href: "http://cvgl.stanford.edu/projects/pascal3d.html",
        text: "Project",
       },
       {href: "ftp://cs.stanford.edu/cs/cvgl/PASCAL3D+_release1.1.zip",
        text: "Data",
       },
       {href: "https://www.youtube.com/watch?v=5Yeus0x6fo0",
        text: "Video",
       },
      ],
    },
    { name: "Multiview Tracking dataset",
     img: "http://cvgl.stanford.edu/projects/multiview_tracking/multiview_tracking.png",
     title: "               <p><a class=link-sytle >Monocular Multiview Object Tracking with 3D Aspect Parts",
     authorsText: "Yu Xiang*, Changkyu Song*, Roozbeh Mottaghi and Silvio Savarese",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2014",
     location: "",
     link: "",
     refs: [
       {href: "http://cvgl.stanford.edu/projects/multiview_tracking",
        text: "Project",
       },
       {href: "https://github.com/changkyu/eccv2014_changkyu",
        text: "Code",
       },
       {href: "http://cvgl.stanford.edu/data/multiview_tracking_dataset.zip",
        text: "Data",
       },
      ],
    },
    { name: "Composable Activities",
     img: "http://www.niebles.net/images/cvpr2014.png",
     title: "Discriminative Hierarchical Modeling of Spatio-Temporally Composable Human Activities",
     authorsText: "Ivan Lillo, Alvaro Soto, Juan Carlos Niebles",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2014",
     location: "",
     link: "https://doi.org/10.1109/CVPR.2014.109",
     refs: [
       {href: "http://ialillo.sitios.ing.uc.cl/ActionsCVPR2014/",
        text: "Project",
       },
       {href: "http://ialillo.sitios.ing.uc.cl/ActionsCVPR2014/",
        text: "Data",
       },
       {href: "https://www.youtube.com/watch?v=_pdfLrie0_8",
        text: "Video",
       },
      ],
    },
    { name: "Semantic Structure From Motion",
     img: "http://vhosts.eecs.umich.edu/vision//projects/ssfm/figures/main_figure_webpage.jpg",
     title: "               <p><a class=link-sytle > Semantic Structure from Motion with Points, Regions, and Objects",
     authorsText: "Sid Yingze Bao, Mohit Bagra, Yu-Wei Chao, and Silvio Savarese",
     venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2012",
     location: "",
     link: "",
     refs: [
       {href: "http://www.eecs.umich.edu/vision/projects/ssfm/index.html",
        text: "Project",
       },
       {href: "https://www.youtube.com/watch?v=bG5SZOzVis8",
        text: "Video",
       },
      ],
    },
    { name: "Olympic Sports",
     img: "http://www.niebles.net/images/cvpr2014.png",
     title: "Modeling Temporal Structure of Decomposable Motion Segments for Activity Classification",
     authorsText: "Juan Carlos Niebles, Chih-Wei Chen and Li Fei-Fei",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2010",
     location: "",
     link: "https://doi.org/10.1109/CVPR.2014.109",
     refs: [
       {href: "http://vision.stanford.edu/Datasets/OlympicSports/",
        text: "Data",
       },
       {href: "http://vision.stanford.edu/documents/NieblesChenFei-Fei_ECCV2010.zip",
        text: "Slides",
       },
      ],
    },
    { name: "Collective Activity",
     img: "http://cvgl.stanford.edu/projects/collective/images/exwait.jpg",
     title: "Collective Activity Classification Using Spatio-Temporal Relationship Among People",
     authorsText: "Wongun Choi, Khuram Shahid, Silvio Savarese",
     venue: "9th International Workshop on Visual Surveillance (VSWS09) in conjuction with ICCV",
     date: "2009",
     location: "",
     link: "https://doi.org/10.1109/CVPR.2014.109",
     refs: [
       {href: "http://cvgl.stanford.edu/projects/collective/collectiveActivity.html",
        text: "Project",
       },
       {href: "http://cvgl.stanford.edu/data/ActivityDataset.zip",
        text: "Data",
       },
      ],
    },
    { name: "ImageNet",
     img: "http://vision.stanford.edu/ilsvrc_proj.jpg",
     title: "ImageNet: a Large-Scale Hierarchical Image Database",
     authorsText: "Jia Deng, Wei Dong, Richard Socher, Li-Jia Li, Kai Li and Li Fei-Fei.",
     venue: "IEEE Computer Society Conference on Computer Vision and Pattern Recognition (CVPR)",
     date: "2009",
     location: "",
     link: "http://www.image-net.org",
     refs: [
       {href: "http://www.image-net.org/",
        text: "Project",
       },
      ],
    },
    { name: "Moving People",
     img: "http://www.niebles.net/images/eccv08.jpg",
     title: "Extracting Moving People from Internet Videos",
     authorsText: "Juan Carlos Niebles, Bohyung Han, Andras Ferencz and Li Fei-Fei",
     venue: "European Conference on Computer Vision (ECCV)",
     date: "2008",
     location: "",
     link: "https://link.springer.com/chapter/10.1007/978-3-540-88693-8_39",
     refs: [
       {href: "http://vision.stanford.edu/projects/extractingPeople.html",
        text: "Project",
       },
       {href: "http://vision.stanford.edu/projects/extractingPeople.html",
        text: "Data",
       },
       {href: "http://vision.stanford.edu/projects/extractingPeople/NieblesHanFerenczFei-Fei_ECCV2008_poster.pdf",
        text: "Poster",
       },
      ],
    },


      ]
    },
    { name: "Code Repositories",
      members: [
      { name: "SURREAL: Open-Source Reinforcement Learning Framework and Robot Manipulation Benchmark",
       img: "/assets/resources/fan2018corl.png",
       title: "",
       authorsText: "Linxi Fan*, Yuke Zhu*, Jiren Zhu, Zihua Liu, Orien Zeng, Anchit Gupta, Joan Creus-Costa, Silvio Savarese, Li Fei-Fei",
       venue: "Conference on Robot Learning (CoRL)",
       date: "2018",
       location: "",
       link: "",
       refs: [
         {href: "http://surreal.stanford.edu/",
          text: "Project",
         },
         {href: "http://surreal.stanford.edu/",
          text: "Code",
         }
        ],
      },
      { name: "Deep Learning under Privileged Information Using Heteroscedastic Dropout",
       img: "https://raw.githubusercontent.com/johnwlambert/dlupi-heteroscedastic-dropout/master/images/pull_figure.png",
       title: "",
       authorsText: "John Lambert*, Ozan Sener*, Silvio Savarese",
       venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
       date: "2018",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/johnwlambert/dlupi-heteroscedastic-dropout",
          text: "Project",
         },
        ],
      },
      { name: "Referring Relationships",
       img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/993559006.png",
       title: "",
       authorsText: "Ranjay Krishna, Ines Chami, Michael Bernstein, Li Fei-Fei",
       venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
       date: "2018",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/stanfordvl/ReferringRelationships",
          text: "Project",
         },
        ],
      },
      { name: "Dense-Captioning Events in Videos",
       img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/published/209126309.png?1493688470",
       title: "",
       authorsText: "Ranjay Krishna, Kenji Hata, Frederic Ren, Li Fei-Fei, Juan Carlos Niebles",
       venue: "International Conference on Computer Vision (ICCV)",
       date: "2017",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/ranjaykrishna/densevid_eval",
          text: "Project",
         },
        ],
      },
      { name: "Feedback Networks",
       img: "http://cvgl.stanford.edu/research/FB_thumbnail.png",
       title: "",
       authorsText: "Amir R. Zamir*, Te-Lin Wu*, Lin Sun, William B. Shen, Bertram Shi, Jitendra Malik, Silvio Savarese",
       venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
       date: "2017",
       location: "",
       link: "",
       refs: [
         {href: "http://feedbacknet.stanford.edu/",
          text: "Project",
         },
        ],
      },
      { name: "Scene Graph Generation by Iterative Message Passing",
       img: "https://cs.stanford.edu/~danfei/scene-graph/preview.jpeg",
       title: "",
       authorsText: "Danfei Xu, Yuke Zhu, Christopher B. Choy, Li Fei-Fei",
       venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
       date: "2017",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/danfeiX/scene-graph-TF-release",
          text: "Project",
         },
        ],
      },
      { name: "Embracing Error to Enable Rapid Crowdsourcing",
       img: "http://ranjaykrishna.com/uploads/3/4/4/6/34464733/8373370.jpg?209",
       title: "",
       authorsText: "Ranjay Krishna, Kenji Hata, Stephanie Chen, Joshua Kravitz, David Ayman Shamma, Li Fei-Fei, Michael Bernstein",
       venue: "CHI",
       date: "2016",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/stanfordhci/rsvp",
          text: "Project",
         },
        ],
      },
      { name: "Perceptual Losses for Real-Time Style Transfer and Super-Resolution",
       img: "https://cs.stanford.edu/people/jcjohns/papers/eccv16/31_muse_mine.png",
       title: "",
       authorsText: "Justin Johnson, Alexandre Alahi, Li Fei-Fei",
       venue: "European Conference on Computer Vision (ECCV)",
       date: "2016",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/jcjohnson/fast-neural-style",
          text: "Project",
         },
        ],
      },
      { name: "DenseCap: Fully Convolutional Localization Networks for Dense Captioning",
       img: "https://cs.stanford.edu/people/jcjohns/papers/densecap/SimpleSystem.svg",
       title: "",
       authorsText: "Justin Johnson, Andrej Karpathy, Li Fei-Fei",
       venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
       date: "2016",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/jcjohnson/densecap",
          text: "Project",
         },
        ],
      },
      { name: "3D-R2N2: 3D Recurrent Reconstruction Neural Network",
       img: "https://github.com/chrischoy/3D-R2N2/blob/master/imgs/pred.png?raw=true",
       title: "",
       authorsText: "Christopher B Choy, Danfei Xu, JunYoung Gwak, Kevin Chen, Silvio Savarese",
       venue: "European Conference on Computer Vision (ECCV)",
       date: "2016",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/chrischoy/3D-R2N2",
          text: "Project",
         },
        ],
      },
      { name: "Enriching Object Detection",
       img: "https://raw.githubusercontent.com/chrischoy/enriching_object_detection/master/data/readme/front.jpg",
       title: "",
       authorsText: " Christopher B Choy, Michael Stark, Sam Corbett-Davies, Silvio Savarese",
       venue: "IEEE Conference on Computer Vision and Pattern Recognition (CVPR)",
       date: "2015",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/chrischoy/enriching_object_detection",
          text: "Project",
         },
        ],
      },
      { name: "Combining 3D Shape, Color, and Motion for Robust Anytime Tracking.",
       img: "https://ai2-s2-public.s3.amazonaws.com/figures/2017-08-08/19b033bdaf8f02cbb2a25abc4d76c9d6317668b5/1-Figure1-1.png",
       title: "",
       authorsText: "David Held, Jesse Levinson, Sebastian Thrun",
       venue: "RSS",
       date: "2014",
       location: "",
       link: "",
       refs: [
         {href: "https://github.com/davheld/precision-tracking",
          text: "Project",
         },
        ],
      },
      ]
    },
  ]
};
